import View from '@picsart/view/View';
import { ReactNode } from 'react';

import usePreviewModal from '../usePreviewModal';
import useStyles from '../styles';

const PreviewModalZoomWrapper = ({ children }: {children: ReactNode}) => {
  const classes = useStyles();
  const {
    onWheel,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onScroll,
    scrollContainerRef,
  } = usePreviewModal();

  return (
    <View
      className={classes.imageZoomScrollBox}
      onScroll={onScroll}
      ref={scrollContainerRef}
    >
      <View
        className={classes.imageZoomContainer}
        onWheel={onWheel}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {children}
      </View>
    </View>
  );
};

export default PreviewModalZoomWrapper;
